import MlQueries from "../MlQueries";

interface RiskParametersProps {
  tenantId: string;
  tenantServiceId: string;
  tenantServiceOptionId: string;
}

export const RiskParameters = ({
  tenantId,
  tenantServiceId,
  tenantServiceOptionId,
}: RiskParametersProps) => {
  return (
    <MlQueries
      tenantId={tenantId}
      tenantServiceId={tenantServiceId}
      tenantServiceOptionId={tenantServiceOptionId}
      category="RISK_PARAMETERS"
      title="Risk Parameters"
    />
  );
};

export default RiskParameters;
